import { red } from '@ant-design/colors'
import { faTrashCan } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Avatar, List, Space } from 'antd'
import { useContext } from 'react'
import { UserDto } from './usersApi'
import UsersPageContext from './UsersPageContext'

type Props = {
  listData: UserDto[]
  onUserSelect: (userEmail: string) => void
}

const UsersSidebarList = ({ listData, onUserSelect }: Props) => {
  const { selectedUserEmail, isDeletedUser } = useContext(UsersPageContext)

  return <List
  dataSource={listData}
  renderItem={(user) => (
    <List.Item
      style={{
        cursor: 'pointer',
        backgroundColor: selectedUserEmail === user.email ? '#4a6b9a' : undefined,
        color: isDeletedUser ? red.primary : undefined,
        padding: '10px 10px'
      }}
      onClick={() => onUserSelect(user.email)}
    >
      <List.Item.Meta
        avatar={<Avatar src={`${user.avatar}?id=${Math.random()}`} size={52} />}
        title={user.displayName}
        description={
          isDeletedUser ? (
            <Space style={{ color: red.primary }}>
              <FontAwesomeIcon icon={faTrashCan} color={red.primary} />
              Deleted
            </Space>
          ) : (
            user.email
          )
        }
      />
    </List.Item>
  )}
/>
}

export default UsersSidebarList